import { UseVisitorDataReturn } from '@fingerprint/react';

/**
 * Creates one identification event per device. FingerprintJS Pro sends a webhook to the server
 * and the fingerprint is upserted there. We skip calling getData if this browser has already
 * registered for this user (try once per device).
 */
export async function registerFingerprint({
  userId,
  getData,
}: {
  userId: string;
  getData: UseVisitorDataReturn['getData'];
}) {
  try {
    const storageKey = `fp_registered_v1:${userId}`;

    const raw = localStorage.getItem(storageKey);
    if (raw) {
      try {
        if (typeof JSON.parse(raw) === 'number') {
          return;
        }
      } catch {
        // Do nothing
      }
    }

    const fp = await getData({
      linkedId: userId,
    });
    if (!fp?.event_id) return;

    localStorage.setItem(storageKey, JSON.stringify(Date.now()));
  } catch {
    // Do nothing
  }
}
